import { Injectable } from '@angular/core';
import { ButtonFactoryService } from '../../button/button-factory.service';
import { ResourceService } from 'sce-core';
import { ButtonItem } from '../../button/button.model';
import { ConfirmDialogService } from 'sce-core';
import { AlertService } from 'sce-core';
import { SearchableEntityActionService } from './searchable-entity-action.service';
import { SearchableEntityDataService } from './searchable-entity-data.service';
import { NavigationService } from '../../../core/navigation.service';
import { PrinterService } from '../printer.service';
import { ModalService } from '../modal.service';
import { CoreServiceRegistry } from '../../../core/core-service-registry';
import { SharedServiceRegistry } from '../../shared-service-registry';
import { JReportPrinterService } from '../jreport-printer.service';

@Injectable()
export class SearchableEntityButtonService {

  protected buttonFactoryService: ButtonFactoryService;
  protected allButtonsMap: Map<string, Array<ButtonItem>>;
  protected userButtonMap: Map<string, Array<ButtonItem>>;
  protected dataService: SearchableEntityDataService;
  protected actionService: SearchableEntityActionService;
  protected resourceService: ResourceService;
  protected confirmDialogService: ConfirmDialogService;
  protected modalService: ModalService;
  public alertService: AlertService;
  protected navService: NavigationService;
  protected printerService: PrinterService;
  protected jReportPrinterService: JReportPrinterService;
  public storerKeys:any;
  public isSearchDynamicBtnExist: boolean = false;
  public searchdDynamicButtons = [];

  public searchMainButtons: Array<ButtonItem>;
  public searchTableButtons: Array<ButtonItem>;

  constructor(protected coreServiceRegistry: CoreServiceRegistry,
    protected sharedServiceRegistry: SharedServiceRegistry) {
    this.buttonFactoryService = sharedServiceRegistry.buttonFactoryService;
    this.resourceService = coreServiceRegistry.resourceService;
    this.navService = coreServiceRegistry.navigationService;
    this.confirmDialogService = sharedServiceRegistry.confirmDialogService;
    this.alertService = sharedServiceRegistry.alertService;
    this.printerService = sharedServiceRegistry.printerService;
    this.jReportPrinterService = sharedServiceRegistry.jReportPrinterService;
    this.modalService = sharedServiceRegistry.sceModalService;
    this.allButtonsMap = this.getAllButtons();
    this.loadButtonsForUser();

    // initialize button panels
    this.searchMainButtons = this.userButtonMap['search-main'];
    this.searchTableButtons = this.userButtonMap['search-table'];
  }

  public setDependentServices(dataService, actionService) {
    this.dataService = dataService;
    this.actionService = actionService;
  }

  public getButtonsForPanel(panelId: string) {
    return this.userButtonMap[panelId];
  }

  /**
   * Default implementation
   */
  protected loadButtonsForUser() {
    this.userButtonMap = new Map<string, Array<ButtonItem>>();
    if (this.allButtonsMap['search-main']) {
      this.userButtonMap['search-main'] = this.buttonFactoryService.loadButtonsByPrivilege(this.allButtonsMap['search-main']);
    } else {
      this.userButtonMap['search-main'] = [];
    }
    if (this.allButtonsMap['search-table']) {
      this.userButtonMap['search-table'] = this.buttonFactoryService.loadButtonsByPrivilege(this.allButtonsMap['search-table']);
    } else {
      this.userButtonMap['search-table'] = [];
    }
  }

  /**
   * Default implementation
   */
  protected getAllButtons(): any {
    return {};
  }

  /**
   * Default implementation
   */
  public performButtonActions(action: any) {
  }

  /**
   * Default implementation
   */
  public printReport() {
  }

  /**
   * Default implementation
   */
  public initializeButtons(cellDataMap?: any) {
  }

  public initializeSearchPageButtons(cellDataMap?: any) {
  }

  /**
   * Default implementation
   */
  protected rebuildButtonArray(buttons: Array<ButtonItem>, displayedActions: Array<string>,
    disabledActions?: Array<string>) {
   this.buttonFactoryService.rebuildButtonArray(buttons, displayedActions);
  }

  /**
   * Default implementation
   */
  public enableAllButtons(buttons: Array<ButtonItem>) {
    this.buttonFactoryService.enableAllButtons(buttons);
  }
  /*LFWM-2240- LF SCE JReport Integration Phase 2 */
  public submitJreport(data) {
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/services/searchable-entity/searchable-entity-button.service.ts